interface ToContractProps {
  masterCustomer: string;
  abgBrand: string;
  contractId: string;
}

export const BASE_ROUTES = {
  login: '/',
  demo: '/demo',
  unauthorized: '/unauthorized',
  preunauthorized: '/preunauthorized',
  customerManagement: '/customer-management',
  approvalWorkflow: '/approval-workflow',
  customerDetails: '/customer-management/customer-details/:masterCustomer/:abgBrand',
  viewContracts: '/customer-management/customer-details/:masterCustomer/:abgBrand/viewContract/:contractId',
  productManagement: '/product-management',
  quote: '/quoting',
  quoteReview: '/quoting/review/:quoteId',
  newQuote: '/quoting/add',
  editQuote: '/quoting/edit/:quoteId',
  copyQuote: '/quoting/copy/:quoteId',
  toContract({ masterCustomer, abgBrand, contractId }: ToContractProps) {
    return this.viewContracts
      .replace(':masterCustomer', masterCustomer)
      .replace(':abgBrand', abgBrand)
      .replace(':contractId', contractId);
  },
};

export const ROUTES = {
  ...BASE_ROUTES,
};
